import {useConfig, watchAccount} from './connectors';
export {connector$, connectMetaMaskWallet, connectWalletConnectWallets, suppportConnectors, type SupportConnectors, disconnect} from './connectors';

const {publicClient} = useConfig();
watchAccount();

export {signMessage} from './signer';
export {publicClient};
